import { render, staticRenderFns } from "./EditarPerfilComponent.vue?vue&type=template&id=1debbf45&scoped=true&"
import script from "./EditarPerfilComponent.vue?vue&type=script&lang=ts&"
export * from "./EditarPerfilComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EditarPerfilComponent.vue?vue&type=style&index=0&id=1debbf45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1debbf45",
  null
  
)

export default component.exports